
import { Options, Vue } from "vue-class-component";
import { readGetSmokeByReport } from "@/store/performance/getters";
import { store } from "@/store";
import {
  dispatchSmokeByReport,
  dispatchSmokeByReportPut,
} from "@/store/performance/actions";
import { dispatchSimpleTaskRecords } from "@/store/task/actions";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import { dateConversion, getLocalProject, typeConversion } from "@/utils";
import { s } from "@fullcalendar/core/internal-common";
import EfficiencyTrend from './efficiency-trend.vue'

// 任务执行详情页面
@Options({
  components: {
    EfficiencyTrend,
  },
})
export default class TaskRecord extends Vue {
  // 部分列表字段其他字段在template里直接定义了)
  public TaskFields = [
    { label: "开始时间", prop: "start" },
    { label: "结束时间", prop: "end" },
    { label: "执行者", prop: "create_user" },
  ];
  // 列表过滤条件：任务名称、状态、执行者
  public name_search: string | "" = "";
  public status_search: number | "" = "";
  public user_search: string | "" = "";

  public loading = false;
  public currentPage1 = 1;
  public record = 16; //记录条数
  public handleEvent(data) {
    data.check = true;

    dispatchSmokeByReportPut(store, {
      id: data.id,
      project: Number(getLocalProject()),
      remark: data.remark,
    });
  }
  // 任务执行状态
  public task_record_status = {
    0: "空闲",
    1: "进行中",
    2: "暂停",
    3: "完成",
    4: "取消",
    5: "异常",
  };
  public datePick = [];
  public async datePickChange() {
    let startTimeAll = dateConversion(this.datePick[0]);
    let endTimeAll = dateConversion(this.datePick[1]);
    let startTime = startTimeAll.split(" ")[0];
    let endTime = endTimeAll.split(" ")[0];

    await dispatchSmokeByReport(store, {
      project: Number(getLocalProject()),
      page: 1,
      size: this.record,
      start: startTime,
      end: endTime,
      search: this.serch_input,
    });
  }
  public defaultTime1 = [
    new Date(2000, 1, 1, 0, 0, 0),
    new Date(2000, 2, 1, 23, 59, 59),
  ];
  public serch_input = "";
  public status_options = [
    {
      label: "空闲",
      value: 0,
    },
    {
      label: "进行中",
      value: 1,
    },
    {
      label: "暂停",
      value: 2,
    },
    {
      label: "完成",
      value: 3,
    },
    {
      label: "取消",
      value: 4,
    },
    {
      label: "异常",
      value: 5,
    },
  ];
  // 从本地缓存获取数据
  public project = Number(getLocalProject());
  public async mounted() {
    this.loading = true;
    const project = this.project;
    await dispatchSmokeByReport(store, {
      project: Number(getLocalProject()),
      page: 1,
      size: this.record,
      start: "",
      end: "",
      search: this.serch_input,
    });
    this.loading = false;
  }

  public handleDetail(row: any, event: any, colume: any) {
    // this.$router.push({
    //     path:'/taskDetails',
    //     query:{
    //         id:row.id,
    // }})
    console.log(row, event, colume);
    if (event.label !== "备注") {
      const { href } = this.$router.resolve({
        path: "/automated_smoke_test",
        query: {
          ...this.$route.query,
          report_id: row.id,
        },
      });
      window.open(href, "_blank");
      return Promise.resolve(false); // 不刷新表格
    }
  }

  public get get_data() {
    readGetSmokeByReport(store)?.results?.forEach((v) => {
      v.date = dateConversion(v.create_date);
      v.check = true;
    });
    return readGetSmokeByReport(store);
  }

  //读取任务记录列表数据

  public async onClear() {
    this.loading = true;
    this.datePick = [];
    this.serch_input = "";
    this.currentPage1 = 1;
    await dispatchSmokeByReport(store, {
      project: Number(getLocalProject()),
      page: 1,
      size: this.record,
      start: "",
      end: "",
      search: this.serch_input,
    });
    this.loading = false;
  }

  // 查询，分页
  public async onSearch(operation: any) {
    this.loading = true;
    if (operation === "Search") {
      this.currentPage1 = 1;
    }
    let startTimeAll = "";

    let endTimeAll = "";
    let startTime = "";
    let endTime = "";
    if (this.datePick) {
      startTimeAll = dateConversion(this.datePick[0]);

      endTimeAll = dateConversion(this.datePick[1]);
      startTime = startTimeAll.split(" ")[0];
      endTime = endTimeAll.split(" ")[0];
    } else {
      startTimeAll = "";
      endTimeAll = "";
    }

    //  if(endTimeAll.split(" ")[1]==='00:00:00'){
    //     endTimeNew=endTime+'\xa0'+'23:59:59'
    // }else{
    //   endTimeNew=endTimeAll
    // }
    await dispatchSmokeByReport(store, {
      project: Number(getLocalProject()),
      page: operation === "Search" ? 1 : this.currentPage1,
      size: this.record,
      start: startTime === "-" ? "" : startTimeAll,
      end: endTime === "-" ? "" : endTimeAll,
      search: this.serch_input,
    });

    this.loading = false;
  }
}
